import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=031aad26&scoped=true"
var script = {}
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=031aad26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031aad26",
  null
  
)

export default component.exports